// extracted by mini-css-extract-plugin
export default {"bottomCtas":"ResetPassword_bottomCtas__h6a-U"};